import { GRADIENT_BTN } from './shared.js';

export default function CTA({ children, onClick, disabled = false, pulse = true, height = 60 }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full rounded-2xl font-display font-extrabold text-[17px] text-bg active:scale-[0.98] transition-transform disabled:opacity-40 disabled:cursor-not-allowed ${
        pulse && !disabled ? 'fc-cta-pulse' : ''
      }`}
      style={{ height, background: GRADIENT_BTN, boxShadow: '0 8px 24px rgba(25,215,242,0.35)' }}
    >
      {children}
    </button>
  );
}
